"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RelativeTime_1 = require("./RelativeTime");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return RelativeTime_1.default; } });
